// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"ef8474cb","301":"3e93a56d","318":"a00380ee","412":"0df4c42f","536":"520384d5"}[chunkId] + ".chunk.js";
};